
import React from "react";
import { CheckCircle } from "lucide-react";

export default function ApprovedNotPublishedStatus() {
  return (
    <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
      <div className="flex items-center gap-2 text-green-800">
        <CheckCircle className="h-4 w-4" />
        <span className="text-sm font-medium">Application Approved</span>
      </div>
      <p className="text-xs text-green-600 mt-1">
        Ready for publishing to marketplace
      </p>
    </div>
  );
}
